export default "__VITE_ASSET__Cl7XXnA2__"